import gql from "graphql-tag";

export const IS_LOGGED_IN = gql`
  query {
    isLoggedIn @client {
      isLoggedIn
    }
  }
`;

export const COUNT_NOTIFICATION = gql`
  query CountNotifications($looked: Boolean) {
    countNotifications(looked: $looked)
  }
`;
